import { render, staticRenderFns } from "./LayoutGroupSetting.vue?vue&type=template&id=3762e2e0&"
import script from "./LayoutGroupSetting.vue?vue&type=script&lang=ts&"
export * from "./LayoutGroupSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports